import { useRouter } from 'next/router'
import Link from 'next/link'
import { PageTab } from 'shared/components/page-tab/page-tab'
import { PageTabGroup } from 'shared/components/page-tab/page-tab-group'
import { PageTabList } from 'shared/components/page-tab/page-tab-list'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { CalendarSectionsEnum, CalendarSectionsLocoKeys } from '../enums/calendar-sections-enum'
import { calendarSections } from '../constants'

const TabMenu = () => {
  const { t } = useLocoTranslation()
  const router = useRouter()
  const section = router.route

  return (
    <PageTabGroup
      className="mt-[-20px]"
      selectedIndex={calendarSections.findIndex(el => el === section)}
    >
      <PageTabList>
        <PageTab onClick={() => router.push(CalendarSectionsEnum.events)}>
          <Link href={CalendarSectionsEnum.events}>{t(`${CalendarSectionsLocoKeys.events}`)}</Link>
        </PageTab>

        <PageTab onClick={() => router.push(CalendarSectionsEnum.bookings)}>
          <Link href={CalendarSectionsEnum.bookings}>
            {t(`${CalendarSectionsLocoKeys.bookings}`)}
          </Link>
        </PageTab>

        <PageTab onClick={() => router.push(CalendarSectionsEnum.availability)}>
          <Link href={CalendarSectionsEnum.availability}>
            {t(`${CalendarSectionsLocoKeys.availability}`)}
          </Link>
        </PageTab>
      </PageTabList>
    </PageTabGroup>
  )
}

export default TabMenu
